import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Typography, Box, Button } from '@mui/material';

const CompanyHeader = ({ company, startDate, isUnassigned = false, onOpenExternalEffortModal, onGenerateReport }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column', md: 'row' }, px: { xs: 2, sm: 4 } }}>
      <Box>
        <Typography variant="h5">{company}</Typography>
        <Typography variant="subtitle1" color="text.secondary" sx={{ mt: 1 }}>
          {moment(startDate).format('MMMM YYYY')}
        </Typography>
      </Box>
      {!isUnassigned && (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', gap: 1 }}>
          <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
            <Button variant="outlined" color="primary" onClick={() => onOpenExternalEffortModal?.(company)}>
              Add additional effort
            </Button>
            <Button variant="contained" color="primary" onClick={() => onGenerateReport?.(company)}>
              Send report
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

CompanyHeader.propTypes = {
  company: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  isUnassigned: PropTypes.bool,
  onOpenExternalEffortModal: PropTypes.func,
  onGenerateReport: PropTypes.func,
};

export default CompanyHeader;
